var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.flashMessages),function(message){return _c('AppAlert',{key:message.text,attrs:{"scheme":message.scheme}},[_vm._v(" "+_vm._s(message.text)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }